import {
  withTooltip,
  THEMES,
  TOOLTIP_HORIZONTAL_ALIGNMENTS,
  TOOLTIP_VERTICAL_ALIGNMENTS,
} from 'cdk-radial';

export const ApiFieldNameTooltip = (data) => {
  const FieldName = (props) => {
    const fieldNameText = data?.fieldName || 'N/A';
    const isRequired = data?.required === true;
    return (
      <div className="api-field-cell" {...props}>
        <div className="api-field-ellipsis">{fieldNameText}</div>
        <div>{isRequired ? '*' : ''}</div>
      </div>
    );
  };

  const ToolTipText = () => {
    return (
      <div className="api_field_tooltip">
        <div>
          <b>Name:</b> {data?.fieldName || 'N/A'}
        </div>
        <div>
          <b>Description:</b> {data?.description || 'N/A'}
        </div>
        <div>
          <b>Example:</b> {data?.example || 'N/A'}
        </div>
      </div>
    );
  };

  const tooltipProps = {
    id: 'api-fields-tooltip',
    text: ToolTipText,
    theme: THEMES.LIGHT,
  };

  const ComponentWithTooltip = withTooltip(FieldName, tooltipProps);
  return (
    <ComponentWithTooltip
      horizontalAlignment={TOOLTIP_HORIZONTAL_ALIGNMENTS.LEFT}
      marginAroundElement={8}
      verticalAlignment={TOOLTIP_VERTICAL_ALIGNMENTS.TOP}
    />
  );
};
